import {useState, useEffect} from 'react';
import axios from 'axios';
import {baseApiUrl} from '../config/const';
import {IFarm} from '../store/reducers/farm';

interface IFarmSettingsDashboard {
  imageGenerationDate: Date | null;
  seasonEndDate: Date | null;
  isCalibrated: boolean | null;
}

export const useFarmSettings = (selectedFarm: IFarm) => {
  const [farmSettings, setFarmSettings] = useState<IFarmSettingsDashboard | null>({imageGenerationDate: null, seasonEndDate: null, isCalibrated: null});

  useEffect(() => {
    const controller = new AbortController();
    const fetchFarmSettings = async () => {
      try {
        const {data} = await axios.get(`${baseApiUrl}/farm-settings/farm/${selectedFarm.id}`, {signal: controller.signal});
        setFarmSettings({
          imageGenerationDate: data?.imageGenerationDate ? new Date(data.imageGenerationDate) : null,
          seasonEndDate: data?.seasonEndDate ? new Date(data.seasonEndDate) : null,
          isCalibrated: data?.isCalibratedMaturity || null,
        });
      } catch (error) {
        console.error('Error fetching farm settings:', error);
      }
    };
    if (selectedFarm?.id) {
      setFarmSettings(null);
      fetchFarmSettings();
    }
    return () => controller.abort();
  }, [selectedFarm]);

  return {farmSettings};
};
